export const NAMESPACE = 'accounts';
